export enum Permission {
  InstacartInternal = 'admin_panel.legacy_permission',
  ProductAttributesEdit = 'catalog_product_attributes.modify', // can edit whether in / out of assortment
  ProductsRetailerCollectionsV2 = 'products_retailer_collections.view', // show "Collections" tab in product view
  ItemAnomalyView = 'catalog_item_anomaly.view', // add Item Anomaly to nav
  ProductsCatalogProductsView = 'products_catalog_products.view',
  ProductsCatalogProductsModify = 'products_catalog_products.modify',
  ProductsSearchCPTModify = 'catalog_problem_tracker.modify', // show button to report problems - internal only
  CatalogProductsView = 'catalog_products.view',
  PackagesDashboardCatalogProductsView = 'packages_dashboard_catalog_products.view',
}
